import axios from '../http';
import { HttpResponse } from '@/types/HttpResponse';
/**
 * @interface deleteParams -删除参数
 * @property {string} orderID -订单号
 */
export interface deleteParams {
  orderID: number;
}
/**
 * @interface getMyOrder
 */
interface getMyOrder {}
//封装接口方法

/**
 * @description 订单相关
 *
 * @return {HttpResponse} result
 */
export class Order {
  /**
   * @description 提交订单
   *
   * @return {HttpResponse} result
   */
  static async sendOrder(data: Object): Promise<HttpResponse> {
    return axios('/addOrder', {
      method: 'post',
      responseType: 'json',
      data: data,
    });
  }
  /**
   * @description 删除订单
   *
   * @return {HttpResponse} result
   */
  static async deleteOrder(params: { orderID: string }): Promise<HttpResponse> {
    return axios('/deleteOrder', {
      method: 'post',
      responseType: 'json',
      params: params,
    });
  }

  /**
   * @description 更改订单信息
   * @param data
   * @returns {HttpResponse} result
   */
  static async setOrder(data: {
    orderId: string;
    seats: string[];
  }): Promise<HttpResponse> {
    return axios('/setOrder', {
      method: 'post',
      responseType: 'json',
      data: data,
    });
  }

  /**
   * @description 返回所有订单
   *
   * @return {HttpResponse} result
   */
  static async getMyOrder(): Promise<HttpResponse> {
    return axios('/getMyOrder', {
      method: 'get',
      responseType: 'json',
    });
  }
  static async getCliamOrder(): Promise<HttpResponse> {
    return axios('/getClaimingOrder', {
      method: 'get',
      responseType: 'json',
    });
  }

  static async postClaim(params: { orderId: string }): Promise<HttpResponse> {
    return axios('/claim', {
      method: 'post',
      responseType: 'json',
      params: params,
    });
  }
  /**
   * @description 获取指定订单信息
   * @param params
   * @returns {HttpResponse} result
   */
  static async getPassengers(data: { orderId: string }): Promise<HttpResponse> {
    return axios('/getOrderByOid', {
      method: 'post',
      responseType: 'json',
      data: data,
    });
  }

  static async getAllOrders(): Promise<HttpResponse> {
    return axios('/getAllOrders', {
      method: 'get',
      responseType: 'json',
    });
  }

  /**
   * @description 选座
   * @param data
   * @returns {HttpResponse} result
   */
  static async selectSeat(data: {
    orderId: string;
    seats: string[];
  }): Promise<HttpResponse> {
    return axios('/updateSeats', {
      method: 'post',
      responseType: 'json',
      data: data,
    });
  }
}
